import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import decode from 'jwt-decode'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loggedInUser: null,
        userIdToken: null,
        userAccessToken: null,
        plans: [
            {
                planName: "Free",
                planFeatures: [
                    "[FREE] This plan has this",
                    "[FREE] and this",
                    "[FREE] oh look another feature!",
                    "[FREE] so many features"
                ],
                isPaidPlan: false
            },
            {
                planName: "Pro",
                planFeatures: [
                    "[PRO] This plan has this",
                    "[PRO] and this",
                    "[PRO] oh look another feature!",
                    "[PRO] so many features"
                ],
                isPaidPlan: true
            },
            {
                planName: "Enterprise",
                planFeatures: [
                    "[ENTERPRISE] This plan has this",
                    "[ENTERPRISE] and this",
                    "[ENTERPRISE] oh look another feature!",
                    "[ENTERPRISE] so many features"
                ],
                isPaidPlan: true
            }
        ]

    },
    getters: {
        showNav: (state) => {
            if (state.loggedInUser == null || state.loggedInUser.has_completed_setup == false) {
                console.log("getterHit")
                return false
            }
            else {
                console.log("getterHit")
                return true
            }
        },
        tokenInfo: (state, getters) => {
            if (getters.isLoggedIn) {
                console.log(decode(state.userIdToken))
                return decode(state.userIdToken)
            }
        },
        idToken: state => {
            return state.userIdToken
        },
        accessToken: state => {
            return state.userAccessToken
        },
        isLoggedIn: (state, getters) => {
            console.log(state.userIdToken)
            console.log("ISLOGGEDIN HIT", !!state.userIdToken && !getters._isTokenExpired(state.userIdToken))
            return !!state.userIdToken && !getters._isTokenExpired(state.userIdToken)
        },
        isAccessTokenExpired: (state, getters) => {
            return !state.userAccessToken || getters._isTokenExpired(state.userAccessToken)
        },
        _isTokenExpired: (state, getters) => (token) => {
            const expirationDate = getters._getTokenExpirationDate(token)
            return expirationDate < new Date()
        },
        _getTokenExpirationDate: () => (encodedToken) => {
            const decodedToken = decode(encodedToken)
            if (!decodedToken.exp) { return null }
            const date = new Date(0)
            date.setUTCSeconds(decodedToken.exp)
            return date
        },
        loginMethod: (state, getters) => {
            if (getters.isLoggedIn) {
                return getters.tokenInfo.sub.split("|")[0]
            }
        }
    },
    mutations: {
        setUserIdToken(state, idToken) {
            console.log("setUserIdToken Mutation HIT")
            state.userIdToken = idToken
        },
        setUserAccessToken(state, accessToken) {
            console.log("setUserAccessToken Mutation HIT")
            state.userAccessToken = accessToken
        },
        setUser(state, user) {
            console.log("setUser Mutation HIT")
            state.loggedInUser = user
        },
        setInvoices(state, invoices) {
            state.loggedInUser.stripe_invoices = invoices
        }
    },
    actions: {
        logout(context) {
            console.log("LOGOUT HIT")
            context.commit('setUserIdToken', null)
            context.commit('setUserAccessToken', null)
            context.commit('setUser', null)
        },
        setUserIdToken(context, idToken) {
            context.commit('setUserIdToken', idToken)
        },
        setUserAccessToken(context, accessToken) {
            context.commit('setUserAccessToken', accessToken)
        },
        async getUserProfile(context) {
            if (context.getters.isLoggedIn) {
                try {
                    let response = await axios.get('/api/user-profile')
                    context.commit('setUser', response.data)
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getStripeInvoices(context) {
            try {
                let response = await axios.get('/api/stripe-invoices/')
                context.commit('setInvoices', response.data.data)
            } catch (error) {
                console.log(error)
            }
        }
    },
    plugins: [createPersistedState()]
})